export default {
    state: {
        user: {}
    },
    mutations: {
        setUser (state, payload) {
            state.user = payload
        }
    },
    actions: {
        getSession (context) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/get_session')
                .then(response => {
                    let user = null

                    if (response.data) {
                        user = response.data
                        context.commit('setUser', user)
                    }

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        logout () {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/logout')
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
